import { IModalDescription } from '@cp/shared/modal';
import { IRegistrationModalProps } from '../ui/registrationModal';

export const REGISTRATION_MODAL: IModalDescription<IRegistrationModalProps> = {
  nss: 'registration',
  loader: () => import('../ui/registrationModal').then((module) => module.RegistrationModal),
};
